module.exports = __webpack_public_path__ + "media/images/teams/logo__4-4789e3523e7ff9489d8c266161bf8330.svg";